import { Children, Fragment } from 'react';

export function SensitiveData({ children }: { children: React.ReactNode }) {
  return (
    <Fragment>
      {Children.map(children, (child: any) => (
        <div className="fs-exclude" data-dd-privacy="mask">
          {child}
        </div>
      ))}
    </Fragment>
  );
}
